import { get } from './requests.js'

const defaults = {
  source: 'datasphere',
}

export const getCreationCount = ({ groupByInterval, source: sourceParam, ...params }) => {
  sourceParam = sourceParam || defaults.source
  const [source, env] = sourceParam.split('-')
  const root = source === 'apa' ? 'analytics/apa' : 'analytics'
  return get(
    [root, 'creation-count', groupByInterval || 'daily'],
    { transformPayload: true },
    { ...params, env }
  )
}

export const getTop10 = ({ type, source: sourceParam, ...params }) => {
  sourceParam = sourceParam || defaults.source
  const [source, env] = sourceParam.split('-')
  const root = source === 'apa' ? 'analytics/apa' : 'analytics'
  return get([root, 'top-10', type || 'users'], { transformPayload: true }, { ...params, env })
}

export const getCreatedByEnum = ({ collection, source: sourceParam, ...params }) => {
  sourceParam = sourceParam || defaults.source
  const [source, env] = sourceParam.split('-')
  const root = source === 'apa' ? ['organizations-apa', collection, 'enum'] : [collection, 'enum']
  return get([...root, 'created_by.email'], { transformPayload: true }, { ...params, env })
}

// Fetches recorded user_events (insights tab) through the events-apa proxy.
// `source` (e.g. "apa-dev") selects the upstream env; the remaining params are
// snake_case filters forwarded straight to the proxy.
export const getInsightsEvents = ({ source: sourceParam, ...params }) => {
  sourceParam = sourceParam || defaults.source
  const [, env] = sourceParam.split('-')
  return get(
    ['events-apa'],
    { removeTrailingSlash: true, transformPayload: true },
    { ...params, env }
  )
}
